import { useSignal } from "@preact/signals";
import { FC } from "preact/compat";
import { TextField } from "~/components";
import { getChats } from "~/core/store";
import { ChatContentProps } from "./interfaces";
import SendIcon from "@material-design-icons/svg/outlined/send.svg";
import { format } from "date-fns";

const ChatContent: FC<ChatContentProps> = ({ chat }) => {
    const chats = getChats();
    const messages = chats.messages(chat.rootThreadId);
    const content = useSignal("");

    const handleSendMessage = () => {
        if (!content.value) {
            return;
        }

        chats.send({
            threadId: chat.rootThreadId,
            content: content.value,
        });
        content.value = "";
    };

    return (
        <div className="h-full max-h-[360px] h-[360px] flex flex-col">
            <div className="flex flex-col-reverse h-full px-4 overflow-y-overlay">
                {messages.value.map((message) => (
                    <div
                        key={message.id}
                        className="p-1 mt-3 bg-gray-100 rounded-lg"
                    >
                        <div className="flex items-start justify-between">
                            <div className="flex items-start">
                                <div className="w-6 h-6 mr-1 bg-gray-200 rounded-full">
                                    <span />
                                </div>
                                <span className="font-bold">
                                    {message.sender.firstName}{" "}
                                    {message.sender.lastName}
                                </span>
                            </div>
                            <div className="text-xs text-gray-500">
                                {format(new Date(message.timestamp), "HH:mm")}
                            </div>
                        </div>
                        <div className="ml-7">{message.content}</div>
                    </div>
                ))}
            </div>
            <div className="h-[60px] px-4 flex items-center">
                <TextField
                    value={content.value}
                    onInput={({ currentTarget }) =>
                        (content.value = currentTarget.value)
                    }
                    onKeyDown={({ key }) => {
                        if (key === "Enter") {
                            handleSendMessage();
                        }
                    }}
                    placeholder="Write a message..."
                    className="w-full"
                />
                <button
                    type="button"
                    onClick={handleSendMessage}
                    className="flex p-2 ml-4 text-gray-500 border border-gray-100 rounded-full hover:text-sky-500 hover:bg-gray-100"
                >
                    <SendIcon className="fill-current" width="18" height="18" />
                </button>
            </div>
        </div>
    );
};

export default ChatContent;
